import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AdminDashboard.module.css';
import { Card } from '../../components/common/Card/Card';
import { Button } from '../../components/common/Button/Button';
import { useAdmin } from './AdminContext';

export const AdminOverview: React.FC = () => {
  const navigate = useNavigate();
  const { stats } = useAdmin();

  return (
    <div className={styles.overviewContainer}>
      <div className={styles.pageHeader}>
        <h1>Admin Dashboard</h1>
        <p>Beheer klanten, projecten en gebruikers</p>
      </div>

      <div className={styles.statsGrid}>
        <Card
          className={styles.statCard}
          onClick={() => navigate('/admin/companies')}
        >
          <div className={styles.statIcon} style={{ background: 'rgba(255, 152, 0, 0.1)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF9800" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{stats.totalCompanies}</span>
            <span className={styles.statLabel}>Klanten</span>
          </div>
        </Card>

        <Card
          className={styles.statCard}
          onClick={() => navigate('/admin/projects')}
        >
          <div className={styles.statIcon} style={{ background: 'rgba(39, 124, 234, 0.1)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#277CEA" strokeWidth="2">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{stats.totalProjects}</span>
            <span className={styles.statLabel}>Projecten</span>
          </div>
        </Card>

        <Card
          className={styles.statCard}
          onClick={() => navigate('/admin/users')}
        >
          <div className={styles.statIcon} style={{ background: 'rgba(230, 0, 126, 0.1)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#E6007E" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{stats.totalUsers}</span>
            <span className={styles.statLabel}>Gebruikers</span>
          </div>
        </Card>

        <Card className={styles.statCard}>
          <div className={styles.statIcon} style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{stats.activeProjects}</span>
            <span className={styles.statLabel}>Actieve projecten</span>
          </div>
        </Card>
      </div>

      <div className={styles.quickActions}>
        <h3>Snelle acties</h3>
        <div className={styles.actionButtons}>
          <Button onClick={() => navigate('/admin/companies/new')}>+ Nieuwe klant</Button>
          <Button onClick={() => navigate('/admin/projects/new')}>+ Nieuw project</Button>
          <Button onClick={() => navigate('/admin/users')}>+ Nieuwe gebruiker</Button>
        </div>
      </div>
    </div>
  );
};
